module.exports = __webpack_public_path__ + "static/media/christian.4ae319a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/comunication/avatar/christian.png
// module id = 446
// module chunks = 0